export const ASSET_DELETE = "deleteAsset";
export const ASSET_EDIT = "editAsset";
export const ASSET_UPLOAD = "uploadAsset";
export const CHECK_AUTH = "checkAuth";
export const CHECK_RESET_TOKEN = "checkResetToken";
export const CONFIG_ITEMS_CREATE = "configItemsCreate";
export const CONFIG_ITEMS_EDIT = "configItemsEdit";
export const FETCH_ASSET = "fetchAsset";
export const FETCH_ASSETS = "fetchAssets";
export const FETCH_CONFIG_ITEMS = "fetchConfigItems";
export const FETCH_LANGS = "fetchLanguages";
export const FETCH_NAVIGATION = "fetchNavigation";
export const FETCH_PAGE = "fetchPage";
export const FETCH_PAGES = "fetchPages";
export const FETCH_USER = "fetchUser";
export const FETCH_USER_BY_ID = "fetchUserById";
export const FETCH_USER_COUNT = "fetchUserCount";
export const FETCH_USERS = "fetchUsers";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const NAVIGATION_EDIT = "navigationEdit";
export const PAGE_DELETE = "deletePage";
export const PAGE_EDIT = "editPage";
export const PAGE_PUBLISH = "publishPage";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";
export const USER_CREATE = "createUser";
export const USER_DELETE = "deleteUser";
export const USER_EDIT = "editUser";
export const USER_RESET_PASSWORD = "resetUserPassword";
export const USER_RESET_ERROR_MESSAGE = "resetUserErrorMessage";
export const USER_UPDATE_PASSWORD = "updateUserPassword";
